import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { setMainApiKey } from '../../config'
import { apiService } from '../../services/api'

const Login = ({ setIsAuth }) => {
	const navigate = useNavigate()
	const [credentials, setCredentials] = useState({ username: '', password: '' })

	const handleSubmit = async e => {
		e.preventDefault()
		// Авторизация
		console.log('Login attempt:', credentials)
		let { isAuth, apiKey } = await apiService.authUser(
			credentials.username,
			credentials.password,
		)
		console.log(apiKey)
		setMainApiKey(apiKey)
		if (isAuth) {
			setIsAuth(true)
			navigate('/')
		} else {
			alert('Неверный логин или пароль')
		}
	}

	return (
		<div className='login-container'>
			<div className='login-card'>
				<h2>Вход в ETL System</h2>
				<form onSubmit={handleSubmit}>
					<div className='form-group'>
						<label>Логин:</label>
						<input
							type='text'
							value={credentials.username}
							onChange={e =>
								setCredentials({ ...credentials, username: e.target.value })
							}
							required
						/>
					</div>
					<div className='form-group'>
						<label>Пароль:</label>
						<input
							type='password'
							value={credentials.password}
							onChange={e =>
								setCredentials({ ...credentials, password: e.target.value })
							}
							required
						/>
					</div>
					<div className='form-actions'>
						<button type='submit' className='button'>
							Войти
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}

export default Login
